export function checkFileExists(url) { // Funktion zur Überprüfung, ob die Datei existiert
    return fetch(url, { method: 'HEAD' })  // HEAD-Anfrage, um nur den Statuscode zu erhalten
        .then(response => {
            if (response.ok) {  // Wenn der Statuscode 200 OK ist, existiert die Datei
                return true;
            } else {
                throw new Error('Datei nicht gefunden oder Serverfehler');
            }
        })
        .catch(error => {
            console.error('Fehler bei der Dateiüberprüfung:', error);
            return false;
        });
}

// CSV-Datei überprüfen und laden, falls sie existiert

   
        // Datei existiert, jetzt die Datei in hauptvariable laden ...
        export async function fetchdat(csvUrl) {
          try {
            const response = await fetch(csvUrl);
            const csvData = await response.text();
            const rows = csvData.trim().split("\n");
            return rows;
          } catch (error) {
            console.error("Fehler beim Laden der B-Plan-Daten...", error);
          
          }
 
        }

        export async function generateLinks(planname,rows) {
            let htmllinks = "";
        
            try {
                
        
                rows.forEach(row => {
                    const columns = row.split(";");
                    if (columns.length === 4) {
                        const name = columns[0];
                        const namezusatz = columns[1];
                        const link = columns[2];
                        const description = columns[3];
                        if (name===planname) {
                        htmllinks += `<a href="${link}" target="_blank" class="popupLink"><div class="blinkstyle">Bebauungsplan ${name} ${namezusatz}<br>${description}</div></a>`;
                        }
                    } else {
                        alert("Fehler: Ungültige B-Plan-Daten");
                    }
                });
                document.getElementById("statuszeile").innerText = htmllinks;
                 //alert(htmllinks);
                return htmllinks; // Jetzt gibt fetchdat() den Wert richtig zurück
            } catch (error) {
                console.error("Fehler beim Laden der CSV-Datei:", error);
                return "Fehler beim Laden der Daten";
            }
        }
   
